<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Add Credit Card
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="close"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <card
        ref="card"
        class="stripe-card"
        :options="stripeOptions"
        :stripe="stripeKey"
      />
      <span
        v-if="errorObj.cardNumberErr"
        class="error"
      >
        {{ errorObj.cardNumberErr }}
      </span>
      <span
        v-if="errorObj.cardExpErr"
        class="error"
      >
        {{ errorObj.cardExpErr }}
      </span>
      <span
        v-if="errorObj.cardCvcErr"
        class="error"
      >
        {{ errorObj.cardCvcErr }}
      </span>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button"
        @click="close"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="addCreditCard"
      >
        Add
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Adding Card"
    />
  </div>
</template>

<script>
import { Card, createToken } from 'vue-stripe-elements-plus';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'CreditCard',
  components: {
    Card,
    ProcessOverlay,
  },
  props: {
    close: Function,
    onSubmit: Function,
  },
  data() {
    return {
      stripeOptions: {
        hidePostalCode: true,
      },
      stripeKey: process.env.STRIPE_KEY,
      errorObj: {},
      processing: false,
    };
  },
  methods: {
    async addCreditCard() {
      this.processing = true;
      const { token, error } = await createToken();
      if (error) {
        if (error.decline_code.includes('test_card')) {
          this.errorObj = {
            cardNumberErr: 'Can\'t use test card in live environment',
          };
        } else {
          this.errorObj = {
            cardNumberErr: 'There was an error processing the card. Please try a different card.',
          };
        }
      } else {
        await this.onSubmit(token.id);
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">

.stripe-card {
  background-color: $NBLUE10;
  padding: 12px 8px;
  border-radius: 4px;
}
</style>
